import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import PageLoader from '../common/PageLoader';
import { LOGIN_LINK } from '../../constants/constants';
const LoginProgress = (props) => {
    return (
        <div data-v-4cc714c5="" className="logo-modal move-top logout-screen">
            <div className="logo-modal-content">
                <div className="error" style={{ textAlign: 'center', marginTop: '3px' }}><PageLoader /></div>
                <div className="error" style={{ textAlign: 'center'}}>You will be redirected to the dashboard page. Please wait..</div>
                <div className="error" style={{ textAlign: 'center', marginTop: "10px"}}><Link style={{ textAlign: 'center', color: "#fff", textDecoration: "none"}} to={LOGIN_LINK}> Trouble? Go to Log In Page</Link></div>
            </div>
        </div>
    )
}
export default LoginProgress